<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_61_1394)">
    <rect x="1" y="1" width="22" height="22" rx="3" fill="#86D6CD" stroke="#00B8AC" stroke-width="2" stroke-linejoin="round"/>
    <path d="M6.42857 13.3286L8.76857 16.3372C8.84753 16.4397 8.94871 16.5231 9.0645 16.581C9.18029 16.6389 9.3077 16.6698 9.43715 16.6714C9.56451 16.6729 9.6906 16.646 9.80625 16.5926C9.9219 16.5392 10.0242 16.4607 10.1057 16.3629L17.5714 7.32858" stroke="#00B8AC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_61_1394">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'CheckedIcon',
};
</script>

<style>

</style>
